module.exports = __webpack_public_path__ + "img/logo-wide.cd382901.svg";